// extracted by mini-css-extract-plugin
module.exports = {"link":"mystyle_link__2Kyum","description":"mystyle_description__6Ve2l","header":"mystyle_header__b-0b4","image":"mystyle_image__3SUQD"};